import {LOCALE_ID, NgModule} from '@angular/core';
import 'hammerjs';
import 'mousetrap';
import {GalleryModule} from '@ks89/angular-modal-gallery';
import {RouteReuseStrategy, RouterModule} from '@angular/router';
import {BrowserModule, HAMMER_GESTURE_CONFIG} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {GestureConfig, MAT_SNACK_BAR_DEFAULT_OPTIONS} from '@angular/material';

import {rootRouterConfig} from './app.routing';
import {SharedModule} from '@shared/shared.module';
import {AppComponent} from './app.component';


import {HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

import {httpInterceptorProviders} from '@shared/http-interceptors';
import {services} from '@shared/services';
import {SimpleReuseStrategy} from './simple-reuse-strategy';
import {PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import localeEnGb from '@angular/common/locales/en-GB';
import {registerLocaleData} from '@angular/common';
import { FullCalendarModule } from '@fullcalendar/angular';
import { AgmCoreModule } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};
registerLocaleData(localeEnGb, 'en-GB')

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    FullCalendarModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    RouterModule.forRoot(rootRouterConfig, {useHash: false, enableTracing: false}),
    PerfectScrollbarModule,
    AgmSnazzyInfoWindowModule,
    GalleryModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBSH-FqXZ6x3v98ukXrM6pUyt08c0Gr2YQ'
    })
  ],
  declarations: [AppComponent],
  providers: [
    // ANGULAR MATERIAL SLIDER FIX
    {provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig},
    {provide: RouteReuseStrategy, useClass: SimpleReuseStrategy},
    {provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {duration: 4000, verticalPosition: 'top', MatSnackBarHorizontalPosition: 'right'}},
    {provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG},
    {provide: LOCALE_ID, useValue: 'en-GB'},
    httpInterceptorProviders,
    ...services
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
